import React, { useCallback } from 'react';

import { useNavigate } from 'react-router';

import ContactUsLink from '@src/components/ContactUsLink';

import styles from './error.scss';

import bootstrap from '@src/css/bootstrap.scss';

const Error500 = () => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <div id="home" className={`col-12 ${styles.error_page}`}>
            <div className={bootstrap.container}>
                <div className={bootstrap.row}>
                    <div className={`${bootstrap.col} ${bootstrap['text-center']}`}>
                        <div className="error-container">
                            <img src="/img/icons/stop-watch-icon.svg" alt="A Stop watch " />
                            <h1>We&#39;re Sorry</h1>
                            <h2>The system has timed out due to a technical error.</h2>
                            <p><a className="link-primary" onClick={handleBackClick}>Go back to a previous page </a> or <ContactUsLink>contact us</ContactUsLink> for help.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error500;
